module.exports = __webpack_public_path__ + "img/logo_default.33872945.svg";